import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const root = css`
  display: grid;
  grid-template-columns: auto auto;
  grid-template-areas:
    'prices rating'
    'saleInfo saleInfo';
  grid-row-gap: ${spacing.base}px;
  align-items: center;
`;

export const prices = css`
  grid-area: prices;
  white-space: nowrap;
`;

export const rating = css`
  grid-area: rating;
  text-align: right;
`;

export const saleInfo = css`
  grid-area: saleInfo;
  ${responsiveText.BODY.SM}
`;

export const from = css`
  display: block;
  ${responsiveText.BODY.MD}
`;

export const currentPrice = css`
  display: inline-block;
  margin: 0;
  ${responsiveText.HEADING.LG}
`;

export const previousPrice = css`
  display: inline-block;
  margin: 0 0 0 ${spacing.sm}px;
  ${responsiveText.HEADING.LG}
`;

export const reviewsLink = css`
  display: block;
  text-decoration: none;
  color: inherit;

  div[role='img'] {
    display: inline-block;
  }
`;

export const smallNumber = css`
  ${responsiveText.BODY.XS};
  font-weight: 600;
`;

export const largeNumber = css`
  margin-left: ${spacing.base}px;
  ${responsiveText.BODY.MD};
  font-weight: 600;
`;

export const reviewsText = css`
  ${responsiveText.BODY.XS};
  font-weight: 600;
  margin-left: ${spacing.base}px;

  a:hover {
    text-decoration: underline;
  }
`;

export const percentageOff = css`
  display: inline-block;
  margin-right: ${spacing.xs}px;
  border-radius: ${spacing.base}px;
  padding: ${spacing.base}px ${spacing.xs}px;
  color: var(--neutral-white-base);
  background-color: var(--functional-red-base);
`;

export const saveAmount = css`
  color: var(--functional-red-base);
`;
